import Stack from "@mui/material/Stack";
import { styled } from "../../../../lib/styled";

interface BottomSheetHandleProps {
  /** Height of the handle in px — must match the SwipeableDrawer's swipeAreaWidth and the
   * negative top offset applied to position it above the drawer's Paper edge. */
  bleeding: number;
}

const HandleRoot = styled(Stack)<{ $bleeding: number }>(({ theme, $bleeding }) => ({
  position: "absolute",
  top: -$bleeding,
  right: 0,
  left: 0,
  height: $bleeding,
  borderRadius: "8px 8px 0 0",
  visibility: "visible",
  backgroundColor: theme.palette.background.paper,
  borderTop: `1px solid ${theme.palette.divider}`,
  alignItems: "center",
  justifyContent: "flex-start",
  paddingTop: theme.spacing(1.5),
}));

const HandlePill = styled("div")(({ theme }) => ({
  width: 32,
  height: 4,
  backgroundColor: theme.palette.action.disabled,
  borderRadius: 2,
}));

/**
 * The visible pull-tab that sits above a collapsed bottom SwipeableDrawer.
 * Position it with `position: "absolute"; top: -bleeding` inside the drawer's Paper
 * so it remains visible (visibility: "visible") when the drawer is closed.
 */
export function BottomSheetHandle({ bleeding }: BottomSheetHandleProps) {
  return (
    <HandleRoot $bleeding={bleeding}>
      <HandlePill />
    </HandleRoot>
  );
}
